// @flow
import React from 'react'
import styled from 'styled-components'
import Dropdown from 'components/Dropdown'
import {observer} from 'mobx-react'
import {toJS} from 'mobx'

import alertStore from 'stores/alert'
import componentStore from 'stores/components'

type State = {
  name: string,
  gridArea: string
}

export default observer(class CopySameLocaleComponent extends React.Component<{}, State> {

    state = {
        name: '',
        gridArea: ''
    }
    
    handleButtonClick = () => {
        const {gridArea, name} = this.state
        if(!name || !gridArea) return
        if(componentStore.components.find(comp => comp.props.gridArea === name)){
            return alertStore.set({
                title: `Name "${name}" wurde bereits vergeben`,
                body: '',
            })
        }
        if(!name.match("^[A-z0-9-]+$")){
            return alertStore.set({
                title: 'Fehler',
                body: `Der Name "${name}" enthält ungültige Zeichen. Es sind nur Zahlen, Buchstaben und "-" erlaubt`
            })
        }
        const component = componentStore.components.find(comp => comp.props.gridArea === gridArea)
        if(!component) return
        const newComponent = JSON.parse(JSON.stringify(toJS(component)))
        // overwrite gridArea and id
        newComponent.props.gridArea = this.state.name
        newComponent.id = Math.random().toString(36).substr(2, 9)

        alertStore.set({
            title: `Kopieren`,
            body: `Willst du die Komponente "${gridArea}" kopieren und den neuen Namen "${name}" vergeben?`,
            onOk: () => componentStore.setComponent(newComponent)
        })
    }

    render(){
        return (
            <Wrapper>
                <Dropdown 
                    placeholder='gridArea'
                    values={componentStore.components.map(comp => comp.props.gridArea)}
                    value={this.state.gridArea}
                    onChange={gridArea => this.setState({gridArea})}
                />
                <input placeholder='new name...' value={this.state.name} onChange={e => this.setState({name: e.target.value})} />
                <Button className="Button" onClick={this.handleButtonClick}>Copy</Button>
            </Wrapper>
        )
    }
})

const Wrapper = styled.div`
    display: flex;
    > .Dropdown { flex: 1; margin-right: 5px; }
    > input { 
      flex: 1; 
      margin-right: 5px; 
      padding-left: 10px;
      height: 45px;
      font-size: 22px;
    }
    > .Button { flex: 1; }
`

const Button = styled.div`
    background: rgb(0, 150, 136);
    padding: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
`


// WEBPACK FOOTER //
// ./src/config/CopySameLocaleComponent.js